import { createContext } from 'react';
var DrawerContext = /*#__PURE__*/createContext({
  isCollapsed: false,
  size: 20
});
if (process.env.NODE_ENV !== 'production') {
  DrawerContext.displayName = 'DrawerContext';
}
export default DrawerContext;